import statuses from '@/store/statuses';
import mutations from './mutations';
import actions from './actions';
import { Backend } from '@/_axios';

import battery from '@/assets/img/icons/battery.svg';
import batteryBg from '@/assets/img/icons/bg/battery.svg';
import can from '@/assets/img/icons/can.svg';
import canBg from '@/assets/img/icons/bg/can.svg';
import pet from '@/assets/img/icons/pet.svg';
import petBg from '@/assets/img/icons/bg/pet.svg';
import tetrapack from '@/assets/img/icons/tetrapack.svg';
import tetrapackBg from '@/assets/img/icons/bg/tetrapack.svg';
import vape from '@/assets/img/icons/vape.svg';
import vapeBg from '@/assets/img/icons/bg/vape.svg';
import vape_salt from '@/assets/img/icons/vape_salt.svg';
import vape_saltBg from '@/assets/img/icons/bg/vape_salt.svg';

const defaultImages = {
  can, canBg,
  tetrapack, tetrapackBg,
  pet, petBg,
  battery, batteryBg,
  vape, vapeBg,
  vape_salt, vape_saltBg,
  };
const baseURL = Backend.defaults.baseURL.split('/api')[0];

const defaultState = () => {
  return {
    depositTypesList: {
      data: [],
      status: statuses.EMPTY,
    },
  };
};

const DepositTypes = {
  namespaced: true,
  state: defaultState,
  getters: {
    depositTypesList: (state) => state.depositTypesList,
    depositTypeImage: (state) => (typeName, bg = false) => {
      const depositTypeImage = state.depositTypesList.data.find((type) => type.type_name === typeName);
      
      if (depositTypeImage && depositTypeImage.image && baseURL) {
        console.log(depositTypeImage.image.path, depositTypeImage.image.path.startsWith('http', 0));
        if (depositTypeImage.image.path.startsWith('http', 0)) {
          return depositTypeImage.image.path;
        }

        return `${baseURL}${depositTypeImage.image.path}`;
      }

      if (bg) {
        return defaultImages[`${typeName}Bg`] || '';
      }

      return defaultImages[typeName] || '';
    }
  },
  mutations,
  actions,
};

export { DepositTypes, defaultState };
